import { render, staticRenderFns } from "./ActivityNote.vue?vue&type=template&id=070fcea6&scoped=true&"
import script from "./ActivityNote.vue?vue&type=script&lang=ts&"
export * from "./ActivityNote.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityNote.vue?vue&type=style&index=0&id=070fcea6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070fcea6",
  null
  
)

export default component.exports